import React, { useEffect, useState } from 'react';
import '../../App.css';
import { AccountDetails } from '../AccountDetails';
import { useSearchParams } from 'react-router-dom';
import {
	getToken,
	getUserPrimaryEmail,
	tokenIsValid,
	setLoginStatus,
	setUserToken,
	setUserTokenExpiry,
	setUserData,
	sessionStorageGetItem,
	sessionStorageSetItem,
} from '../Function';

function MyAccount() {
	const [searchParams, setSearchParams] = useSearchParams();
	const token = searchParams.get('key');
	const token_expiry = searchParams.get('expiry');
	const login = sessionStorageGetItem('login');
	const SERVER_URL = process.env.REACT_APP_SERVER_URL;
	const [userLoyalty, setUserLoyalty] = useState([]);
	const email = getUserPrimaryEmail();
	if (!token && !token_expiry && login == null) {
		window.location.href = '/';
	}

	useEffect(() => {
		if (token) {
			const getUserProfileByToken = async () => {
				try {
					const response = await fetch(
						`${SERVER_URL}/user/profile/token/${token}/${token_expiry}`,
						{
							headers: {
								Authorization: getToken(),
							},
						}
					);
					if (!response.ok) {
						throw new Error(
							`This is an HTTP error: The status is ${response.status}`
						);
					}
					let actualData = await response.json();
					setLoginStatus(true);
					setUserToken(token);
					setUserTokenExpiry(token_expiry);
					setUserData(actualData);
					sessionStorageSetItem('userData', JSON.stringify(actualData));
					sessionStorageSetItem('login', JSON.stringify(true));
					sessionStorageSetItem(
						'primaryEmail',
						JSON.stringify(actualData.primaryemail)
					);
					if (actualData && !email) {
						window.location.reload();
					}
				} catch (err) {
					console.log(err);
				} finally {
					// setLoading(false)
				}
			};
			tokenIsValid();
			getUserProfileByToken();
		}

		//user loyalty data history (via Express API proxy - no direct reward-API/CORS dependency)
		const user_loyalty = `${SERVER_URL}/reward/transactions/${email}`;

		const getUserLoyalty = async () => {
			try {
				const user_loyalty_response = await fetch(user_loyalty, {
					method: 'GET',
					mode: 'cors',
					headers: {
						Authorization: getToken(),
					},
				});
				if (!user_loyalty_response.ok) {
					throw new Error(
						`This is an HTTP error: The status is ${user_loyalty_response.status}`
					);
				}
				let myUserLoyalty = await user_loyalty_response.json();
				setUserLoyalty(myUserLoyalty.results);
				// sessionStorageSetItem("userLoyaltyData", JSON.stringify(myUserLoyalty.results));
				// console.log(myUserLoyalty.results)
			} catch (err) {
				console.log('error');
				setUserLoyalty([]);
			}
		};
		tokenIsValid();
		getUserLoyalty();
	}, [getToken()]);

	if (email)
		return (
			<>
				<AccountDetails userLoyalty={userLoyalty} />
			</>
		);
}

export default MyAccount;
